export default __webpack_public_path__ + "media/images/rapport-vert-02213fa7197799a7609e9276a83795e0.png";